import React, { memo } from 'react';
import PastTrip from './PastTrip/PastTrip';
import PlannedTrip from './PlannedTrip/PlannedTrip';
const TripsItemComponent = ({ trip }) => {
    return ((trip === null || trip === void 0 ? void 0 : trip.plannedPickUpAt)
        ? React.createElement(PlannedTrip, { trip: trip })
        : React.createElement(PastTrip, { trip: trip }));
};
const TripsItem = memo(TripsItemComponent);
TripsItem.displayName = 'TripsItem';
export default TripsItem;
